import React, { useState, useEffect } from "react";
import axios from "axios";
import ImprimoListas from "./ImprimoListas";
import socket from "../tools/socke";

const ListadoSecciones = ({categoria}) => {
  const [compania, setCompania] = useState(""); // Estado para la compañía seleccionada
  const [seccion, setSeccion] = useState(""); // Estado para la sección seleccionada
  const [sede, setSede] = useState("");
  const [promocion, setPromocion] = useState("");
  const [listadoSeleccionado, setListadoSeleccionado] = useState([]); // Listado de cadetes seleccionados
  const [secciones, setSecciones] = useState([]); // Secciones obtenidas de la API
  const [compañias, setCompanias] = useState([]); // Compañías agrupadas
  const [visible, setVisible] = useState(false);
  const [datosSeccion, setdatosSeccion] = useState("");
  const [cargando, setCargando] = useState(false);
  const [divisiones, setdivisiones] = useState([]);
  
  const [filtros, setFiltros] = useState({
   
    Convocado: false,
    Excluido: false,
    Regular: true,
    Propedeutico: false,
    Reempadronar: false,
    Renuncia: false,
    BAJA: false,
    LiEs: false,
    
  });
  // Función para obtener las secciones desde la API
  const obtenerSecciones = async () => {
    try {
     
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/devuelveSecciones"
      );
      const seccionesData = response.data || [];
//       console.log(seccionesData)
      setSecciones(seccionesData);

      // Agrupar las secciones por compañía
      const companiasAgrupadas = seccionesData.reduce((acc, seccion) => {
        const { nombre } = seccion.Compania;
        if (!acc[nombre]) {
          acc[nombre] = [];
        }
        acc[nombre].push(seccion);
        return acc;
      }, {});

      // Obtener los nombres de las compañías para el primer select
      setCompanias(Object.keys(companiasAgrupadas));
    } catch (error) {
      console.error("Error al obtener las secciones", error);
    }
  };

  const obtenerDivisiones = async () => {
    try {
     
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveDivision"
      );
      const divisionData = response.data || [];

      setdivisiones(divisionData);

      // Agrupar las secciones por compañía
  
    } catch (error) {
      console.error("Error al obtener las secciones", error);
    }
  };
  useEffect(() => {
        obtenerDivisiones()
    obtenerSecciones();

       
   
}, [listadoSeleccionado]); 





  const devuelveListadoPorSeccion = async (dato) => {
    try {
      setCargando(true);
      setVisible(false);
  
      const filtrosSeleccionados = Object.keys(filtros).filter(key => filtros[key]); // Filtra solo los filtros activos
  
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorSeccion/${dato}`,
        {
          cadeteEstado: "Activo",  // Puedes ajustar este valor según tu lógica
          cadeteCondicion: filtrosSeleccionados=="Todos"?"":filtrosSeleccionados,  // Aquí pasas el filtro
        }
      );
//   console.log(response)
      setListadoSeleccionado(response.data || []);
      setVisible(true);
    } catch (error) {
      console.error("Error en la petición", error);
    }
    setCargando(false);
  };
  const devuelveListadoPorCompania = async (dato) => {
    try {
      setCargando(true);
      setVisible(false);

      // Determina el índice de la compañía seleccionada
      const consulta = compañias.findIndex(x => x == dato) + 1;
  
   // Filtra solo los filtros activos
const filtrosSeleccionados = Object.keys(filtros).filter(
  key => filtros[key]
);

// console.log(filtrosSeleccionados);

// Si entre los filtros está "baja", entonces el estado es "Suspendido"
const cadeteEstado = filtrosSeleccionados.includes("baja")
  ? "Suspendido"
  : "Activo";

// Enviar los filtros junto con el id de la compañía
const response = await axios.post(
  `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorCompania/${consulta}`,
  {
    cadeteEstado,
    cadeteCondicion: filtrosSeleccionados,
  }
);
//       console.log(response);
      setListadoSeleccionado(response.data || []);
      setVisible(true);
    } catch (error) {
      console.error("Error en la petición", error);
    }
    setCargando(false);
  };
  const devuelveListadoPorSede = async (dato) => {
    try {
      setCargando(true);
      setVisible(false);
  
      // Determina el índice de la compañía seleccionada
     
  
      // Filtra solo los filtros activos
      const filtrosSeleccionados = Object.keys(filtros).filter(key => filtros[key]); // Filtros seleccionados
  
      // Enviar los filtros junto con el id de la compañía
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorSede/${dato}`,
        {
          cadeteEstado: "Activo",  // Puedes ajustar este valor según tu lógica
          cadeteCondicion: filtrosSeleccionados,  // Pasando los filtros seleccionados
        }
      );
  
//       console.log(response);
      setListadoSeleccionado(response.data || []);
      setVisible(true);
    } catch (error) {
      console.error("Error en la petición", error);
    }
    setCargando(false);
  };









  
 const devuelveListadoDivision = async (dato) => {
    try {
      
      setCargando(true);
      setVisible(false);
  
      // Determina el índice de la compañía seleccionada
     
  
      // Filtra solo los filtros activos
      const filtrosSeleccionados = Object.keys(filtros).filter(key => filtros[key]); // Filtros seleccionados
  
      // Enviar los filtros junto con el id de la compañía
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorDivision/${dato}`,

      );
  
//       console.log(response);
      setListadoSeleccionado(response.data || []);
      setVisible(true);
    } catch (error) {
      console.error("Error en la petición", error);
    }
    setCargando(false);
  };
  // Función para manejar el cambio en la selección de la compañía






  const devuelveListadoPorPromocion = async (dato) => {
    try {
      setCargando(true);
      setVisible(false);
  
      // Determina el índice de la compañía seleccionada
     
  
      // Filtra solo los filtros activos
      const filtrosSeleccionados = Object.keys(filtros).filter(key => filtros[key]); // Filtros seleccionados
  
      // Enviar los filtros junto con el id de la compañía
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadetesPorPromocionCondicion/${dato}`,
        {
      
          cadeteCondicion: filtrosSeleccionados,  // Pasando los filtros seleccionados
        }
      );
//   console.log(filtrosSeleccionados)
//       console.log(response.data);
      setListadoSeleccionado(response.data.cadetes || []);
      setVisible(true);
    } catch (error) {
      console.error("Error en la petición", error);
    }
    setCargando(false);
  };
  // Función para manejar el cambio en la selección de la compañía
  const handleCompaniaChange = (e) => {

    const selectedCompania = e.target.value;
//         console.log(selectedCompania)
    if(categoria=="Seccion"){
     
      setCompania(selectedCompania);
      setSeccion(""); // Limpiar la sección al cambiar la compañía
      setListadoSeleccionado([]); // Limpiar listado
      setVisible(false);
    }
    else if(categoria=="Compania"){
      devuelveListadoPorCompania(selectedCompania)
    }

  };

  // Función para manejar el cambio en la selección de la sección
  const handleSeccionChange = (e) => {
    const selectedSeccion = e.target.value;
    setSeccion(selectedSeccion);

    if (selectedSeccion) {
      setdatosSeccion(secciones.find(x => x.id == selectedSeccion));
   
      devuelveListadoPorSeccion(selectedSeccion);
    }
  };
  
  const handlePromocionChange = (e) => {
    
    const selectrdPromocion = e.target.value;
    setPromocion(selectrdPromocion);

    if (selectrdPromocion) {
     
      devuelveListadoPorPromocion(selectrdPromocion);
//       console.log(selectrdPromocion)
    }
  };
  const handleSedeChange = (e) => {
    
    const selectrdSede = e.target.value;
    setSede(selectrdSede);

    if (selectrdSede) {
     
      devuelveListadoPorSede(selectrdSede);
//       console.log(selectrdSede)
    }
  };
  const handleDivisionChange = (e) => {
    
    const selectrdDivision = e.target.value;
//     console.log(selectrdDivision);

    if (selectrdDivision) {
     
      devuelveListadoDivision(selectrdDivision);
  
    }
  };
  
  const handleFiltroChange = (e) => {
    const { name, checked } = e.target;

    if (name === "Todos") {
      // Si "Todos" es seleccionado, desmarcar los demás
      setFiltros({
      
        Convocado: false,
        Excluido:false,
        Regular: true,
        Propedeutico: false,
        Reempadronar: false,
        Renuncia: false,
        BAJA: false,
        LTB: false,
        LiEs: false,
      });
    } else {
      // Si "Todos" no es seleccionado, actualizar solo ese filtro
      setFiltros((prev) => ({
        ...prev,
        [name]: checked,
      }));
    }
  };
  const selecTodos = () => {
    const allChecked = Object.values(filtros).every((val) => val); // Si todos están marcados
    const nuevoEstado = Object.keys(filtros).reduce((acc, key) => {
      acc[key] = !allChecked; // Invierte el estado actual
      return acc;
    }, {});

    setFiltros(nuevoEstado);
  };
  return (

    <>
     {/* Filtros con checkboxes */}
     <div style={{ marginBottom: "10px",display:"flex", width:"100%", justifyContent:"center"}}>
     <div style={{ marginBottom: "10px",display:"flex", width:"90%", flexWrap:"wrap", alignItems:"center", justifyContent:"center" }}>
     <button className="btn btn-secondary" onClick={selecTodos}>Todos</button>
              
            <label style={{padding:"5px"}}>
              <input
             
                type="checkbox"
                name="Convocado"
                checked={filtros.Convocado}
                onChange={handleFiltroChange}
              />
              Convocado
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="Regular"
                checked={filtros.Regular}
                onChange={handleFiltroChange}
              />
              Regular
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="Propedeutico"
                checked={filtros.Propedeutico}
                onChange={handleFiltroChange}
              />
              Propedeutico
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="Reempadronar"
                checked={filtros.Reempadronar}
                onChange={handleFiltroChange}
              />
              Reempadronar
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="Renuncia"
                checked={filtros.Renuncia}
                onChange={handleFiltroChange}
              />
              Renuncia
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="Excluido"
                checked={filtros.Excluido}
                onChange={handleFiltroChange}
              />
              Excluido
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="BAJA"
                checked={filtros.BAJA}
                onChange={handleFiltroChange}
              />
              BAJA
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="LTB"
                checked={filtros.LTB}
                onChange={handleFiltroChange}
              />
              LTB
            </label>
            <label style={{padding:"5px"}}>
              <input
                type="checkbox"
                name="LiEs"
                checked={filtros.LiEs}
                onChange={handleFiltroChange}
              />
              LiEs
            </label>
            
          </div></div>
{categoria=="Seccion"?
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
   
    <div style={{ marginBottom: "10px" }}>
      <select value={compania} onChange={handleCompaniaChange}>
        <option value="">Selecciona una Compañía</option>
        {compañias.map((comp, index) => (
          <option key={index} value={comp}>
            {comp}
          </option>
        ))}
      </select>
    </div>

   
    {compania && (
      <div style={{ marginBottom: "10px" }}>
        <select value={seccion} onChange={handleSeccionChange}>
          <option value="">Selecciona una Sección</option>
          {secciones
            .filter((seccion) => seccion.Compania.nombre === compania) // Filtrar las secciones por la compañía seleccionada
            .map((seccion) => (
              <option key={seccion.id} value={seccion.id}>
                {seccion.nombre} {seccion.descripcion}
              </option>
            ))}
        </select>
      </div>
    )}

    {/* Cargando y listado */}
    {cargando && <p>Cargando...</p>}

    {visible && (
      <div style={{ textAlign: "center" }}>
        <ImprimoListas cadetesData={listadoSeleccionado} titulo={"Seccion"} />
        <p>Total Cadetes: {listadoSeleccionado.length}</p>
      </div>
    )}
  </div></div>:
  ""}

{categoria=="DivisionEstudio"?
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
   
   <div style={{ marginBottom: "10px" }}>
      <select value={compania} onChange={handleDivisionChange}>
        <option value="">Selecciona una División</option>
        {/* Mapear las divisiones para generar las opciones */}
        {divisiones.map((division) => (
          <option key={division.id} value={division.id}>
            {division.nombreDivision} {/* Mostrar el nombre de la división */}
          </option>
        ))}
      </select>
    </div>

   
   

    {/* Cargando y listado */}
    {cargando && <p>Cargando...</p>}

    {visible && (
      <div style={{ textAlign: "center" }}>
        <ImprimoListas cadetesData={listadoSeleccionado} titulo={"Division"} />
        <p>Total Cadetes: {listadoSeleccionado.length}</p>
      </div>
    )}
  </div></div>:
  ""}





  {categoria=="Compania"?
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
   
    <div style={{ marginBottom: "10px" }}>
      <select value={compania} onChange={handleCompaniaChange}>
        <option value="">Selecciona una Compañía</option>
        {compañias.map((comp, index) => (
          <option key={index} value={comp}>
            {comp}
          </option>
        ))}
      </select>
    </div>

    {/* Selección de sección, dependiendo de la compañía seleccionada */}
   

    {/* Cargando y listado */}
    {cargando && <p>Cargando...</p>}

    {visible && (
      <div style={{ textAlign: "center" }}>
        <ImprimoListas cadetesData={listadoSeleccionado} titulo={" Compania"} />
        <p>Total Cadetes: {listadoSeleccionado.length}</p>
      </div>
    )}
  </div></div>:
  ""}

{categoria=="Sede"?
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
   
    <div style={{ marginBottom: "10px" }}>
    <select value={compania} onChange={handleSedeChange}>
  <option value="">Selecciona una Sede</option>
  <option value="Rosario">Rosario</option>
  <option value="Recreo">Recreo</option>
</select>
</div>
       
      
    </div>

    {/* Selección de sección, dependiendo de la compañía seleccionada */}
   

    {/* Cargando y listado */}
    {cargando && <p>Cargando...</p>}

    {visible && (
      <div style={{ textAlign: "center" }}>
        <ImprimoListas cadetesData={listadoSeleccionado} titulo={datosSeccion} />
        <p>Total Cadetes: {listadoSeleccionado.length}</p>
      </div>
    )}
  </div>:
  ""}
{categoria=="Promocion"?
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
   
    <div style={{ marginBottom: "10px" }}>
    <select value={promocion} onChange={handlePromocionChange}>
  <option value="">Selecciona una Promocion</option>
  <option value="1">2024-2025</option>
  <option value="2">2025-2026</option>
    <option value="4">2026-2027</option>
</select>
</div>
       
      
    </div>

    {/* Selección de sección, dependiendo de la compañía seleccionada */}
   

    {/* Cargando y listado */}
    {cargando && <p>Cargando...</p>}

    {visible && (
      <div style={{ textAlign: "center" }}>
        <ImprimoListas cadetesData={listadoSeleccionado} titulo={"Promocion"} />
        <p>Total Cadetes: {listadoSeleccionado.length}</p>
      </div>
    )}
  </div>:
  ""}














</>
  );
};

export default ListadoSecciones;
